var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"eia-unit-switcher"},_vm._l((_vm.units),function(unit){return _c('eia-link',{key:unit.id,on:{"click":function($event){return _vm.switchDisplayUnits( unit )}}},[_vm._v("Change to "+_vm._s(unit.displayLongName))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }